import { Switch } from '@blueprintjs/core';
import React, { useState, useEffect, useRef } from 'react';
// import {useStripe, useElements, CardElement} from '@stripe/react-stripe-js';
import http from '../../../services/httpService';
import { getCurrentUserId, getJwt } from '../../../services/authService';
import InputRegular from '../../common/InputRegular';
import toastr from 'toastr';
import ProPlanSuccessModal from '../../modals/ProPlanSuccessModal';
import {CardComponent, CardNumber, CardExpiry, CardCVV} from '@chargebee/chargebee-js-react-wrapper';

import CardSection from './CardSection';

export default function CardSetupForm(props) {
    const [name, setName] = useState(props.billingDetails.billing_name);
    const [loader, setLoader] = useState(false);
    const [proPlanSuccessModalActive, setProPlanSuccessModalActive] = useState(false)
    const [paymentErrorMessage, setPaymentErrorMessage] = useState('');
    const [showDiscountInput, setShowDiscountInput] = useState(false);
    const [discountCode, setDiscountCode] = useState('');
    const [fieldsCheckActive, setFieldsCheckActive] = useState(false);
    const [errorsList, setErrorsList] = useState([]);
    const [couponLoader, setCouponLoader] = useState(false);
    const [confirmed_promo_code, set_confirmed_promo_code] = useState('');
    const [confirmed_promo_code_percentage, set_confirmed_promo_code_percentage] = useState('');
    const [upcomingSwitchPlans, setUpcomingSwitchPlans] = useState('')
    const [clientSecret, setClientSecret] = useState('')

    const [chargeBeeErrors, setChargeBeeErrors] = useState([]);
    const [chargeBeeErrorMessage, setChargeBeeErrorMessage] = useState([]);

    const [chargeBeeClasses, setChargeBeeClasses] = useState({
        focus: 'focus',
        invalid: 'invalid',
        empty: 'empty',
        complete: 'complete',
    });

    // const stripe = useStripe();
    // const elements = useElements();
    //console.log('freeTrial: ', props.freeTrial);

    window.Chargebee.init({
        site: process.env.REACT_APP_ENVIRONMENT === 'DEV' ? "emitto-test" : "emitto",
        publishableKey: process.env.REACT_APP_CHARGEBEE
    })

    const CardRef = useRef(null);

    let onChange = (status) => {
        // console.log('onChange: ', status.error)
        if(status && status.error){
            // let errMessages = Object.values(errors).filter(message => !!message);
            setChargeBeeErrors({
                ...chargeBeeErrors,
                [status.field]: status.error || ''
            });
            setChargeBeeErrorMessage(status.error.message);
        }
    }

    let onReady = (el) => {
        el.focus();
    }

    const handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();

        // if (!stripe || !elements) {
        //     // Stripe.js has not yet loaded.
        //     // Make sure to disable form submission until Stripe.js has loaded.
        //     return;
        // }


        setPaymentErrorMessage('');
        let user = await props.user;
        let projectId = await props.selectedSource || localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        let project = await user.sources.data.find(project => projectId.toString() === project.id.toString())
        let details = await props.billingDetails;
        // let client_secret = clientSecret;
        let viberPlan = props.viberPlan;
        setLoader(true);
        // let useDiscount = (new Date() > new Date('11/19/2020 00:00')) && (new Date() < new Date('12/07/2020 23:59 (CET)'))
        let useDiscount = props.stripePlanId && props.stripePlanId.includes('yearly') ? true : false
        let stripePlanId = props.stripePlanId || '';
        // if(user && !user.customer){
        //     try{
        //         const stripeResult = await http.post('api/user/' + user.id + '/project/' + projectId + '/customers/create_customer',{}, {headers: {authorization: getJwt()}})
        //     }catch{
        //         toastr.error("Stripe Customer wasn't created, please try again")
        //     }
        //
        // }
        // if(!clientSecret){
        //     try{
        //         const stripeResult = await http.post('api/user/' + user.id + '/project/' + projectId + '/customers/create_setup_intent',{}, {headers: {authorization: getJwt()}});
        //         if (stripeResult.data && stripeResult.data.client_secret) {
        //             client_secret = await stripeResult.data.client_secret;
        //         }
        //     }catch (e) {
        //         toastr.error("Stripe setup intent wasn't created. Please check data and try again.")
        //         setLoader(false);
        //     }
        //
        // }

        // console.log('stripeResult: ', stripeResult)
        // if (client_secret) {

            // console.log('client_secret: ', client_secret)

            let token = '';
            if(CardRef) {
                // Call tokenize method on card element
                // CardRef.current.tokenize().then((data) => {
                //     console.log('chargebee token', data.token)
                //     token = data.token;
                // }).catch(error=>{
                //     // console.log('error: ', error)
                //     setLoader(false);
                //     toastr.error(error)
                //     setPaymentErrorMessage(error)
                // });
                try{
                    let response = await CardRef.current.tokenize();
                    // console.log('chargebee token', response.token)
                    token = response.token;
                }catch(error){
                    setLoader(false);
                    toastr.error('Check the card number',error?.message)
                    setPaymentErrorMessage('Error with card token, please try again.')
                }
            }
                // The setup has succeeded. Display a success message and send
                // result.setupIntent.payment_method to your server to save the
                // card to a Customer

            if(token && stripePlanId){
                try {
                    const resultUpdatePaymentMethod = await http.post('api/user/' + user.id + '/project/' + projectId + '/customers/update_payment_methods',
                        {
                            "cb_token": token
                        },
                        {headers: {authorization: getJwt()}}
                    );
                    // console.log('resultUpdatePaymentMethod: ', details, resultUpdatePaymentMethod)
                    if (details && resultUpdatePaymentMethod && resultUpdatePaymentMethod.data && resultUpdatePaymentMethod.data.payment_method) {
                        /* This part needs to be uncommented and checked in which cases it breaks */

                        // const details = props.billingDetails
                        try {
                            const resultUpdateBillingDetails = await http.post('api/user/' + user.id + '/project/' + projectId + '/pm/' + resultUpdatePaymentMethod.data.payment_method_default.id + '/update',
                                {
                                    "billing_details": {
                                        "address": {
                                            "city": details.address.city || '',
                                            "country": details.address.country || '',
                                            "line1": details.address.line1 || '',
                                            "line2": null,
                                            "postal_code": details.address.postal_code || '',
                                            "state": details.address.state || ''
                                        },
                                        "email": details.email || '',
                                        "phone": details.phone || '',
                                        "company_name": details.company_name || '',
                                        "billing_name": details.billing_name || '',
                                        "vat_number": details.vat_number || '',
                                        "po_number": details.po_number || ''
                                    }
                                },
                                {headers: {authorization: getJwt()}}
                            );
                        } catch (e) {
                            setLoader(false);
                            toastr.error("Billing details update wasn't successful.");
                        }

                        try {

                            let smsPlatform = project && project.platforms ? project.platforms.find(platform => platform.platform === 'sms') : '';
                            // console.log('props amount and addedNumbers: ', stripePlanId, smsPlatform)
                            if (smsPlatform.plan && stripePlanId) {
                                // console.log('Usao 1')
                                // let smsPlatform = project.platforms.find(platform => platform.platform === 'sms');
                                if (smsPlatform.plan === 'free_plan') {
                                    try{
                                        const proPlanResult = await http.post('api/user/' + user.id + '/project/' + projectId + '/customers/switch_plans', {
                                            "plan": stripePlanId,
                                            'freeTrial': props.freeTrial,
                                            "use_discount": confirmed_promo_code ? 0 : useDiscount ? 1 : 0,
                                            "promo_code": confirmed_promo_code
                                        },{headers: {authorization: getJwt()}})

                                        if(proPlanResult.data && proPlanResult.data.error){
                                            // Display result.error.message in your UI.
                                            setLoader(false);
                                            // toastr.error(result.data.message)
                                            // setPaymentErrorMessage(result.data.message)
                                            toastr.error(proPlanResult.data.error)
                                            setPaymentErrorMessage(proPlanResult.data.error)
                                        }else if (proPlanResult) {
                                            setLoader(false);
                                            handleSubscriptionCompleted(stripePlanId)
                                            props.updateUserFromServer()
                                            // setProPlanSuccessModalActive(true);
                                        }

                                    }catch(e){
                                        toastr.error("Switching of plan wasn't successfull");
                                        setLoader(false);
                                    }
                                }
                            } else {
                                // console.log('Usao 2')
                                const proPlanResult = await http.post('api/user/' + user.id + '/project/' + projectId + '/customers/subscribe_to_plan', {
                                    "plan": stripePlanId,
                                    'freeTrial': props.freeTrial,
                                    "use_discount": confirmed_promo_code ? 0 : useDiscount ? 1 : 0,
                                    "promo_code": confirmed_promo_code
                                }, { headers: { authorization: getJwt() } })
                                // console.log('proPlanResult: ', proPlanResult)
                                if(proPlanResult.data && proPlanResult.data.error){
                                    // Display result.error.message in your UI.
                                    setLoader(false);
                                    // toastr.error(result.data.message)
                                    // setPaymentErrorMessage(result.data.message)
                                    toastr.error(proPlanResult.data.error)
                                    setPaymentErrorMessage(proPlanResult.data.error)
                                    handleClearCoupon()
                                } else if(proPlanResult){
                                    setLoader(false);
                                    handleClearCoupon()
                                    handleSubscriptionCompleted(stripePlanId)
                                    // setProPlanSuccessModalActive(true);
                                }
                            }
                            // } else if (props.fundsAmount && props.addedNumbers && props.addedNumbers.length) {
                            //     // console.log('Usao 4')
                            //     /* Case when buing phone numbers */
                            //     setLoader(false);
                            //     props.history.push('/pay-phone-numbers-existing-payment', {
                            //         amount: props.fundsAmount,
                            //         addedNumbers: props.addedNumbers
                            //     })
                            // } else if (viberPlan){
                            //     // console.log('Usao 3')
                            //     setLoader(false);
                            //     props.history.push('/viber-subscription-existing-payment',{
                            //         viberSelectedPlan: viberPlan
                            //     });
                            // } else if (props.fundsAmount && props.topUpViber) {
                            //     /* Case when buing phone numbers */
                            //     setLoader(false);
                            //     props.history.push('/topup-existing-payment', {
                            //         amount: props.fundsAmount
                            //     })
                            // } else {
                            //     setLoader(false);
                            //     toastr.error("Payment wasn't successful. Please try again.");
                            // }
                        } catch (e) {
                            setLoader(false);
                            toastr.error("Signing for Premium plan wasn't successful. Please try again.");
                        }

                    }else if(resultUpdatePaymentMethod && resultUpdatePaymentMethod.data && resultUpdatePaymentMethod.data.error){
                        setLoader(false);
                        toastr.error(resultUpdatePaymentMethod.data.error);
                    }
                    // console.log('resultUpdatePaymentMethod: ', resultUpdatePaymentMethod)
                } catch (e) {
                    setLoader(false);
                    toastr.error("Setting default payment method wasn't successful, please try again");
                }

            }else if(token){
                toastr.error("Problem with plan Id. Please reload page and try again.");
            }

            // } catch (e) {
            //     setLoader(false);
            //     toastr.error('Error: ', e.error.message)
            // }

            // if (result.error) {
            //     // Display result.error.message in your UI.
            //
            // } else {
            //
            //
            //
            // }
        // }


    };

    const handleSubscriptionCompleted = (planId) => {
        //console.log('planId: ', planId)
        if (planId === 'tester_monthly') {
            props.history.push('/tester-monthly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/tester-monthly-confirmation',
                pageTitle: 'Tester Monthly Confirmation',
            });
        } else if (planId === 'starter_monthly') {
            props.history.push('/starter-monthly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/essentials-monthly-confirmation',
                pageTitle: 'Essentials Monthly Confirmation',
            });
        } else if (planId === 'essentials_monthly') {
            props.history.push('/essentials-monthly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/essentials-monthly-confirmation',
                pageTitle: 'Essentials Monthly Confirmation',
            });
        } else if (planId === 'boost_monthly') {
            props.history.push('/boost-monthly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/boost-monthly-confirmation',
                pageTitle: 'Boost Monthly Confirmation',
            });
        } else if (planId === 'tester_yearly') {
            props.history.push('/tester-yearly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/tester-yearly-confirmation',
                pageTitle: 'Tester Yearly Confirmation',
            })
        } else if (planId === 'starter_yearly') {
            props.history.push('/starter-yearly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/starter-yearly-confirmation',
                pageTitle: 'Starter Yearly Confirmation',
            })
        } else if (planId === 'essentials_yearly') {
            props.history.push('/essentials-yearly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/essentials-yearly-confirmation',
                pageTitle: 'Essentials Yearly Confirmation',
            });
        } else if (planId === 'boost_yearly') {
            props.history.push('/boost-yearly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/boost-yearly-confirmation',
                pageTitle: 'Boost Yearly Confirmation',
            });
        } else {
            props.history.push('/subscription-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/subscription-confirmation',
                pageTitle: 'Subscription Confirmation',
            });
        }
    }

    const handleApplyCoupon = async (e) => {
        e.preventDefault();

        let user = await props.user;
        let projectId = await props.selectedSource || localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';

        setCouponLoader(true);
        try {
            const result = await http.post('/api/user/' + user.id + '/project/' + projectId + '/customers/upcoming_switch_plans',{
                plan: props.stripePlanId,
                use_discount: 0,
                promo_code: discountCode
            }, {headers: {authorization: getJwt()}});
            // await setUpcomingSwitchPlans(result.data)
            if (result && result.data && result.data.invoice_upcoming && result.data.invoice_upcoming.invoiceEstimate &&
                result.data.invoice_upcoming.invoiceEstimate.lineItems && result.data.invoice_upcoming.invoiceEstimate.lineItems.length &&
                result.data.invoice_upcoming.invoiceEstimate.lineItems[0].discountAmount ) {
                set_confirmed_promo_code(discountCode);
                // set_confirmed_promo_code_percentage(result.data.invoice_upcoming.discount.coupon.percent_off);
                setCouponLoader(false);
                setErrorsList([]);
                setFieldsCheckActive(false)
                setUpcomingSwitchPlans(result.data.invoice_upcoming)
                props.updateUpcomingSwitchPlans(result.data.invoice_upcoming)
            }else{
                set_confirmed_promo_code('');
                // set_confirmed_promo_code_percentage('');
                setCouponLoader(false);
                setErrorsList(result && result.data && result.data.error ? [result.data.error] : ['Wrong coupon. Please add a valid discount code value!']);
                setFieldsCheckActive(true)
            }
        }catch(e){
            set_confirmed_promo_code('');
            // set_confirmed_promo_code_percentage('');
            setCouponLoader(false);
            setErrorsList(['Wrong coupon. Please add a valid discount code value!']);
            setFieldsCheckActive(true)
        }
        setCouponLoader(false);
    }

    const handleClearCoupon = () => {
        props.updateUpcomingSwitchPlans('') ;
        setDiscountCode('');
        set_confirmed_promo_code('');
        // set_confirmed_promo_code_percentage('');
        setUpcomingSwitchPlans('');
    }

    const updateErrorsList = async (error, id) => {
        // let errorsList = await this.state.errorsList;
        // errorsList[parseInt(id) - 1] = await error;
        // await this.setState({errorsList})
        //console.log('errorsList: ', errorsList)
    }

    return (
        <form onSubmit={handleSubmit} className='card-input-container'>
            <div style={{margin: '0 0 10px 0'}}>
                <InputRegular
                    id="1"
                    label1="Card Holder Name"
                    placeholder="John Doe"
                    type='text'_project
                    onChange={value => setName(value)}
                    value={name}
                    // required={true}
                    fieldsCheckActive={false}
                    // updateErrorsList={updateErrorsList}
                    errorMessage="Card holder name can't be empty"
                />
            </div>

            <div className="ex2-fieldset">
                {/*<label className="ex2-field">*/}
                {/*    <span className="ex2-label">Name</span>*/}
                {/*    <input name="firstName" className={ this.state.firstName ? "ex2-input val" : "ex2-input"} type="text" placeholder="John Doe" value={this.state.firstName} onChange={this.handleChange} />*/}
                {/*</label>*/}
                {/*<label className="ex2-field">*/}
                {/*    <span className="ex2-label">Email</span>*/}
                {/*    <input name="email" className={ this.state.email ? "ex2-input val" : "ex2-input"} type="text" placeholder="john@comp.any" value={this.state.email} onChange={this.handleChange} />*/}
                {/*</label>*/}
                {/*<label className="ex2-field">*/}
                {/*    <span className="ex2-label">Phone</span>*/}
                {/*    <input name="phone" className={ this.state.phone ? "ex2-input val" : "ex2-input"} type="text" placeholder="+63 53242 32637" value={this.state.phone} onChange={this.handleChange} />*/}
                {/*</label>*/}

                <label className="ex2-field">
                    {/* Render card component in combined-mode */}
                    <CardComponent ref={CardRef} className="ex2-input fieldset field"
                        // icon={cardIcon}
                                   styles={{
                                       base: {
                                           color: '#293A4A',
                                           fontWeight: '500',
                                           fontFamily: 'Lato,-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, sans-serif',
                                           fontSize: '14px',
                                           fontSmoothing: 'antialiased',
                                           iconColor: '#293A4A',

                                           ':focus': {
                                               // color: '#424770',
                                           },

                                           '::placeholder': {
                                               color: '#abacbe',
                                           },

                                           ':focus::placeholder': {
                                               color: '#abacbe',
                                           },
                                       },
                                       invalid: {
                                           color: '#E94745',

                                           ':focus': {
                                               color: '#e44d5f',
                                           },
                                           '::placeholder': {
                                               color: '#FFCCA5',
                                           },
                                       },
                                   }}
                        // classes={classes}
                    />
                </label>
            </div>
            {/*<div id="errors">{chargeBeeErrorMessage}</div>*/}

            {/*<CardSection/>*/}
            <p style={{marginTop: 20}} className='discount-code' onClick={()=>setShowDiscountInput(!showDiscountInput)}>I have a promo code</p>
            {
                showDiscountInput ?
                    <div className='coupon-container'>
                        <InputRegular
                            id={'1'}
                            label1=""
                            label2=""
                            placeholder="DISCOUNT_CODE"
                            type='always-error'
                            onChange={ async (value)=> {
                                setDiscountCode(value)
                                setFieldsCheckActive(false)
                            }}
                            value={discountCode}
                            required={true}
                            fieldsCheckActive={fieldsCheckActive}
                            updateErrorsList={updateErrorsList}
                            errorMessage="Wrong coupon. Please add a valid discount code value!"
                        />
                        { couponLoader ?
                            <button className='blue-button-spinner' disabled={true}>Apply Coupon <i className='fa fa-spin fa-spinner'></i></button>
                            :
                            <button className='blue-button' onClick={ handleApplyCoupon }>Apply Coupon</button>
                        }
                    </div>
                    :
                    ''
            }
            {
                showDiscountInput && confirmed_promo_code ?
                    <p className='green-text-coupon'>Promo code is confirmed</p>
                    :
                    ''
            }
            <div className='flex-end' style={{margin: '20px 0'}}>
                {loader ?
                    <button className='btn-action' disabled={true}>Pay With Card <i className='fa fa-spin fa-spinner'></i>
                    </button>
                    :
                    <button className='btn-action' >Pay With Card</button>
                }
            </div>
            {/*{console.log('CardSetupForm props: ', props)}*/}
            {/*<ProPlanSuccessModal*/}
                {/*showModal={proPlanSuccessModalActive}*/}
                {/*handleClose={() => {*/}
                    {/*setProPlanSuccessModalActive(false)*/}
                    {/*props.history.push('/subscription-confirmation');*/}
                {/*}}*/}
                {/*maxWidth={500}*/}
                {/*history={props.history}*/}
            {/*/>*/}
        </form>
    );
}